'use client';
import { useEffect } from 'react';
 import Icon from'@/components/ui/AppIcon';

const FeaturesSection = () => {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal')
    if (!reveals.length) return
    
    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    )
    reveals.forEach(el => observer.observe(el))
  }, [])

  const features = [
    {
      id: 'feature_modes',
      icon: 'AcademicCapIcon',
      title: 'Dual Study Modes',
      description: 'Study mode with instant explanations or test mode for realistic exam simulation.',
      color: 'bg-primary/10 text-primary',
    },
    {
      id: 'feature_categories',
      icon: 'FolderIcon',
      title: 'Topic Selection',
      description: 'Choose specific categories and topics to focus your study time where needed most.',
      color: 'bg-accent/10 text-accent',
    },
    {
      id: 'feature_timer',
      icon: 'ClockIcon',
      title: 'Flexible Timers',
      description: 'Set custom time limits from 30 minutes to 2 hours for realistic test conditions.',
      color: 'bg-warning/10 text-warning',
    },
    {
      id: 'feature_explanations',
      icon: 'LightBulbIcon',
      title: 'Detailed Explanations',
      description: 'Get comprehensive explanations with images when you select wrong answers.',
      color: 'bg-success/10 text-success',
    },
  ]

  return (
    <section id="features" className="py-24 bg-background">
      <div className="container px-6">
        <div className="text-center mb-16 reveal">
          <span className="text-sm font-semibold text-primary uppercase tracking-wider mb-3 block">
            Features
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-foreground tracking-tight mb-4">
            Everything You Need to Succeed
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Powerful features designed to make your aviation test preparation efficient and effective.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 max-w-7xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={feature.id}
              className="group bg-card rounded-2xl p-6 sm:p-8 border border-border hover:border-primary/50 transition-all hover:shadow-xl reveal"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className={`w-12 h-12 sm:w-14 sm:h-14 ${feature.color} rounded-xl flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform`}>
                <Icon name={feature.icon as any} size={24} className="sm:w-7 sm:h-7" />
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-foreground mb-2 sm:mb-3">
                {feature.title}
              </h3>
              <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FeaturesSection